// NPM PACKAGE IMPORTS
import styled from "styled-components";

// CONSTANTS
const aqua = "#78ffdf";

// EXPORTS
export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  background-color: #333;

  height: 100vh;
  width: 100vw;

  @media (min-width: 769px) {
    flex-direction: unset;
  }
`;

export const Link = styled.a`
  width: 60vw;
  display: grid;
  justify-items: center;

  @media (min-width: 769px) {
    width: 30vw;
  }
`;

export const Image = styled.img`
  width: 60%;
  transition: all 0.3s ease;

  :hover {
    transform: scale(1.2);
  }
`;

export const Logout = styled.div`
  position: fixed;
  top: 15px;
  left: 15px;
  border: 2px solid #fff;
  background-color: transparent;
  color: #fff;
  width: 50px;
  height: 50px;
  font-size: 3rem;
  font-weight: bold;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border-color: ${aqua};
    color: ${aqua};
  }

  &:active {
    transform: scale(0.8);
  }
`;
